import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "../Location.css";

import TestimonialCard from "./TestimonialCard";
import { testimonials } from "./testimonials";

const TestimonialSection = () => {
  return (
    <section className="testimonial-section">
      <div className="testimonial-container">

        <div className="testimonial-header">
          <h2 className="testimonial-title">
            What Our Customers Say
          </h2>

          <p className="testimonial-subtitle">
            Discover why thousands of families trust us for their RO service and
            maintenance needs.
          </p>
        </div>

        <Swiper
          modules={[Pagination, Autoplay]}
          pagination={{ clickable: true }}
          autoplay={{
            delay: 3500,
            disableOnInteraction: false,
          }}
          spaceBetween={30}
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 1,
            },
            1024: {
              slidesPerView: 2,
            },
          }}
          className="testimonial-swiper"
        >
          {testimonials.map((item) => (
            <SwiperSlide key={item.id}>
              <TestimonialCard testimonial={item} />
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="testimonial-pagination">
          <div className="swiper-pagination"></div>
        </div>

      </div>
    </section>
  );
};

export default TestimonialSection;